const routes = [
  {
    enabled: true,
    key: 'ET_TUBE',
    label: {
      en: 'EtTube',
      es: 'Tubo endotraqueal',
    },
    defaultUnits: ['WEIGHT_G', 'WEIGHT_MG', 'WEIGHT_MCG'],
  },
  {
    enabled: true,
    key: 'IV_IO_PUSH',
    label: {
      en: 'IV/IO Push',
      es: 'IV/IO Push',
    },
    defaultUnits: ['WEIGHT_G', 'WEIGHT_MG', 'WEIGHT_MCG'],
  },
  {
    enabled: true,
    key: 'IV_IO_INFUSION',
    label: {
      en: 'IV/IO Infusion',
      es: 'IV/IO Infusion',
    },
    defaultUnits: ['WEIGHT_G', 'WEIGHT_MG', 'WEIGHT_MCG'],
  },
  {
    enabled: true,
    key: 'INTRAMUSCULAR',
    label: {
      en: 'Intramuscular',
      es: 'Intramuscular',
    },
    defaultUnits: ['WEIGHT_G', 'WEIGHT_MG', 'WEIGHT_MCG'],
  },
  {
    enabled: true,
    key: 'INTRANASAL',
    label: {
      en: 'Intranasal',
      es: 'Intranasal',
    },
    defaultUnits: ['WEIGHT_G', 'WEIGHT_MG', 'WEIGHT_MCG'],
  },
  {
    enabled: true,
    key: 'NEBULIZER',
    label: {
      en: 'Nebulizer',
      es: 'Nebulizador',
    },
    defaultUnits: ['WEIGHT_G', 'WEIGHT_MG', 'WEIGHT_MCG'],
  },
  {
    enabled: true,
    key: 'ORAL',
    label: {
      en: 'Oral',
      es: 'Oral',
    },
    defaultUnits: ['WEIGHT_G', 'WEIGHT_MG', 'WEIGHT_MCG'],
  },
  {
    enabled: true,
    key: 'SUBCUTANEOUS',
    label: {
      en: 'Subcutaneous',
      es: 'Subcutánea',
    },
    defaultUnits: ['WEIGHT_G', 'WEIGHT_MG', 'WEIGHT_MCG'],
  },
  {
    enabled: true,
    key: 'SUBLINGUAL',
    label: {
      en: 'Sublingual',
      es: 'Sublingual',
    },
    defaultUnits: ['WEIGHT_G', 'WEIGHT_MG', 'WEIGHT_MCG'],
  },
  {
    key: 'INTRADERMAL',
    label: {
      en: 'Intradermal',
      es: '',
    },
    defaultUnits: ['WEIGHT_G', 'WEIGHT_MG', 'WEIGHT_MCG'],
  },
  {
    key: 'METERED_DOSE_INHALER',
    label: {
      en: 'Metered Dose Inhaler',
      es: '',
    },
    defaultUnits: ['WEIGHT_G', 'WEIGHT_MG', 'WEIGHT_MCG'],
  },
  {
    key: 'TRANSDERMAL',
    label: {
      en: 'Transdermal',
      es: '',
    },
    defaultUnits: ['WEIGHT_G', 'WEIGHT_MG', 'WEIGHT_MCG'],
  },
  {
    key: 'TRANSMUCOSAL',
    label: {
      en: 'Transmucosal',
      es: '',
    },
    defaultUnits: ['WEIGHT_G', 'WEIGHT_MG', 'WEIGHT_MCG'],
  },
  {
    key: 'RECTAL',
    label: {
      en: 'Rectal',
      es: '',
    },
    defaultUnits: ['SUPPOSITORY'],
  },
  {
    key: 'TOPICAL',
    label: {
      en: 'Topical',
      es: '',
    },
    defaultUnits: ['INCHES'],
  },
]
 
routes.forEach(route => {
  // Backwards compatibility with components that expect `route.name` instead of `route.label`
  route.name = route.label;
})
 
module.exports = routes;